import React from 'react';
import PdfMerger from './components/PdfMerger';
import './App.css';

function App() {
  return (
    <div className="App">
      <PdfMerger />
    </div>
  );
}

export default App;
